/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
import { CommonContractorCreateUpdateApp } from '../../../../Dashboard/Contractors/Functionality/ContractorCreateUpdateFlows/CommonContractorCreateUpdateApp';
import { EmployeeFlowSupplierUpdateApp } from '../../Funtionality/SupplierCreateUpdateFlows/EmployeeFlowSupplierUpdateApp';
import { permissionObj } from '../../../../../Helpers/permission';
import routes from '../../../../../Routes/routes';
import HeadTittle from '../../../../../components/HeadTittle';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import { EditIcon } from '../../../../../components/buttons/IconButtons';
import React from 'react';
import CopySecretModal from '../../../../Dashboard/Company/Employees/Modal/CopySecretModal';
import { isValidLengthDocumentId, validateMinLengthTrimmed } from '../../../../../Apis/functions';
import { PASSWORD_MIN_LENGTH } from '../../../../../constant/variable';
import UnlinkDeviceBtn from '../../../../../components/buttons/UnlinkDeviceBtn';
import EmployeeFlowSupplierUpdateWithoutExtraData from './EmployeeFlowSupplierUpdateWithoutExtraData';
import EmployeeFlowSupplierUpdateWithExtraData from './EmployeeFlowSupplierUpdateWithExtraData';

const EmployeeFlowSupplierUpdate = () => {
    const props = CommonContractorCreateUpdateApp();

    const {
        t,
        dispatch,
        navigate,
        DEV,
        params,
        permission,
        isValidEmail,
        isValidPhoneNumber,
        isValidDob,
        setIsValidDob,
        isValidDocumentId,
        isValidPassword,
        setIsValidPassword,
        setIsValidDocumentId,
        userInfoStatusList,
        emptyFields,
        setEmptyFields,
        handleDateChange,
        handleEmailChange,
        handlePasswordChange,
        handlePhoneNumberChange,
        validateEmail,
        validatePhone,
        secretModal,
        setSecretModal,
        secretKey,
        setSecretKey,
        disabled,
        activeStep,
        setActiveStep,
        steps,
        setSteps,
        handleStepChange,
        photoPicker,
        setPhotoPicker,
        modified,
        setModified,
        extraData,
        extraDataEnabled,
        setExtraData,
        setExtraDataEnabled,
        headersList,
    } = props;

    const { user, setUser, FormHandler, getAllServiceType, goBack, showUnlinkBtn, handleChange } =
        EmployeeFlowSupplierUpdateApp({
            t,
            params,
            dispatch,
            navigate,
            permission,
            setEmptyFields,
            isValidDob,
            isValidPassword,
            photoPicker,
            setSecretModal,
            setSecretKey,
            setSteps,
            modified,
            setModified,
            setPhotoPicker,
            extraData,
            extraDataEnabled,
            setExtraData,
            setExtraDataEnabled,
            headersList,
        });

    if (
        !DEV &&
        (!permission?.includes(permissionObj.WEB_SUPPLIER_READ) ||
            !permission?.includes(permissionObj.WEB_SUPPLIER_UPDATE))
    )
        navigate(routes.forbidden);

    return (
        <>
            <HeadTittle onBack={goBack} name={t('update')}>
                {(DEV || permission?.includes(permissionObj.WEB_SUPPLIER_UPDATE)) && (
                    <ButtonAction
                        id={'btn_efs_update'}
                        name={'update'}
                        className={'btn-icon-edit'}
                        disabled={false}
                        Icon={EditIcon}
                        onClick={() => {
                            validateEmail(user.email);
                            validatePhone(user.phoneNumber);
                            const isValid = validateMinLengthTrimmed(user.password, {
                                minLength: PASSWORD_MIN_LENGTH,
                                allowEmpty: true,
                            });
                            const docummentIdOk = isValidLengthDocumentId(user.documentId);
                            setIsValidPassword(isValid);
                            setIsValidDocumentId(docummentIdOk);
                            if (!isValid || !docummentIdOk) return;
                            FormHandler();
                        }}
                    />
                )}
                {showUnlinkBtn && <UnlinkDeviceBtn userId={user.userId} updated={() => setModified(true)} />}
            </HeadTittle>
            {extraDataEnabled ? (
                <EmployeeFlowSupplierUpdateWithExtraData
                    t={t}
                    user={user}
                    dispatch={dispatch}
                    navigate={navigate}
                    DEV={DEV}
                    params={params}
                    permission={permission}
                    isValidEmail={isValidEmail}
                    isValidPhoneNumber={isValidPhoneNumber}
                    isValidDob={isValidDob}
                    setIsValidDob={setIsValidDob}
                    isValidDocumentId={isValidDocumentId}
                    isValidPassword={isValidPassword}
                    setIsValidPassword={setIsValidPassword}
                    setIsValidDocumentId={setIsValidDocumentId}
                    userInfoStatusList={userInfoStatusList}
                    emptyFields={emptyFields}
                    setEmptyFields={setEmptyFields}
                    handleDateChange={handleDateChange}
                    handleEmailChange={handleEmailChange}
                    handlePasswordChange={handlePasswordChange}
                    handlePhoneNumberChange={handlePhoneNumberChange}
                    validateEmail={validateEmail}
                    validatePhone={validatePhone}
                    secretModal={secretModal}
                    setSecretModal={setSecretModal}
                    secretKey={secretKey}
                    setSecretKey={setSecretKey}
                    disabled={disabled}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    steps={steps}
                    setSteps={setSteps}
                    handleStepChange={handleStepChange}
                    photoPicker={photoPicker}
                    setPhotoPicker={setPhotoPicker}
                    modified={modified}
                    setModified={setModified}
                    extraData={extraData}
                    setExtraData={setExtraData}
                    setExtraDataEnabled={setExtraDataEnabled}
                    extraDataEnabled={extraDataEnabled}
                    headersList={headersList}
                    setUser={setUser}
                    handleChange={handleChange}
                    getAllServiceType={getAllServiceType}
                />
            ) : (
                <EmployeeFlowSupplierUpdateWithoutExtraData
                    t={t}
                    user={user}
                    dispatch={dispatch}
                    navigate={navigate}
                    DEV={DEV}
                    params={params}
                    permission={permission}
                    isValidEmail={isValidEmail}
                    isValidPhoneNumber={isValidPhoneNumber}
                    isValidDob={isValidDob}
                    setIsValidDob={setIsValidDob}
                    isValidDocumentId={isValidDocumentId}
                    isValidPassword={isValidPassword}
                    setIsValidPassword={setIsValidPassword}
                    setIsValidDocumentId={setIsValidDocumentId}
                    userInfoStatusList={userInfoStatusList}
                    emptyFields={emptyFields}
                    setEmptyFields={setEmptyFields}
                    handleDateChange={handleDateChange}
                    handleEmailChange={handleEmailChange}
                    handlePasswordChange={handlePasswordChange}
                    handlePhoneNumberChange={handlePhoneNumberChange}
                    validateEmail={validateEmail}
                    validatePhone={validatePhone}
                    secretModal={secretModal}
                    setSecretModal={setSecretModal}
                    secretKey={secretKey}
                    setSecretKey={setSecretKey}
                    disabled={disabled}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    steps={steps}
                    setSteps={setSteps}
                    handleStepChange={handleStepChange}
                    photoPicker={photoPicker}
                    setPhotoPicker={setPhotoPicker}
                    modified={modified}
                    setModified={setModified}
                    headersList={headersList}
                    setUser={setUser}
                    getAllServiceType={getAllServiceType}
                />
            )}
            <CopySecretModal
                show={secretModal}
                setShow={setSecretModal}
                secret={secretKey}
                setSecret={setSecretKey}
                setData={setUser}
                onHide={() => {}}
                closeText={'close'}
            />
        </>
    );
};
export default EmployeeFlowSupplierUpdate;
